<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>

  <div class="main-panel">
    <header class="topbar">
      <h1>Plataforma Unica de Postulacion</h1>
      <div class="topbar-right">
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>

    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>

    <main class="content">
      <section class="card form-shell" *ngIf="postulacion && permisos.visible; else sinDetalleTpl">
        <section class="form-card hero-card">
          <div class="hero-head">
            <div>
              <h2>{{ tituloFormularioVisible }}</h2>
              <p class="subtitle">
                Completa cada seccion del formulario. Los campos marcados con <span class="required-mark">*</span> son obligatorios.
              </p>
            </div>

            <div class="hero-aside" *ngIf="esSoloLectura || rol === 'ayudante_postulante'">
              <span class="mode-chip" *ngIf="esSoloLectura">Solo lectura</span>
              <span class="mode-chip mode-chip-soft" *ngIf="rol === 'ayudante_postulante'">Ayudante no puede enviar</span>
            </div>
          </div>
        </section>

        <section class="form-card summary-card" aria-label="Resumen de la postulacion">
          <article class="summary-item">
            <span class="summary-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M8 3h7l4 4v14H5V3h3Z" />
                <path d="M15 3v5h5" />
                <path d="M8 12h8" />
                <path d="M8 16h8" />
              </svg>
            </span>
            <div class="summary-copy">
              <small>ID Postulacion</small>
              <strong>{{ postulacion.idPostulacion }}</strong>
            </div>
          </article>

          <article class="summary-item">
            <span class="summary-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M4 15v-2a3 3 0 0 1 3-3h2l2 2h2l2-2h2a3 3 0 0 1 3 3v2" />
                <path d="M9 10a3 3 0 1 1 6 0" />
                <path d="M3 15h2v4H3z" />
                <path d="M19 15h2v4h-2z" />
              </svg>
            </span>
            <div class="summary-copy">
              <small>Concurso</small>
              <strong>{{ postulacion.concurso }}</strong>
            </div>
          </article>

          <article class="summary-item">
            <span class="summary-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M8 3h7l4 4v14H5V3h3Z" />
                <path d="M15 3v5h5" />
                <path d="M8 12h8" />
                <path d="M8 16h6" />
              </svg>
            </span>
            <div class="summary-copy">
              <small>Folio</small>
              <strong>{{ postulacion.folio }}</strong>
            </div>
          </article>

          <article class="summary-item">
            <span class="summary-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M12 7.5v5l3 2" />
              </svg>
            </span>
            <div class="summary-copy">
              <small>Estado</small>
              <strong>
                <span class="summary-state-pill">{{ etiquetaEstadoPostulacionActual }}</span>
              </strong>
            </div>
          </article>

          <article class="summary-item">
            <span class="summary-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <circle cx="12" cy="8" r="3.5" />
                <path d="M5 20a7 7 0 0 1 14 0" />
              </svg>
            </span>
            <div class="summary-copy">
              <small>Rol activo</small>
              <strong>{{ rolActivoLabel }}</strong>
            </div>
          </article>
        </section>

        <section class="progress-card" aria-label="Avance de la postulacion">
          <div class="progress-head">
            <div>
              <h3>Avance de la postulacion</h3>
              <p class="progress-subtitle">El indicador se actualiza con los campos y adjuntos completados en cada seccion.</p>
            </div>

            <div class="progress-total">
              <strong>{{ avanceGeneral }}%</strong>
              <span>{{ seccionesCompletas }} de {{ avanceSecciones.length }} secciones completadas</span>
            </div>
          </div>

          <div class="progress-metrics">
            <article class="progress-metric">
              <span class="progress-metric-label">Linea actual</span>
              <strong>{{ indicePasoActivo + 1 }}/{{ pasos.length }}</strong>
            </article>

            <article class="progress-metric">
              <span class="progress-metric-label">Progreso</span>
              <strong>{{ avanceGeneral }}%</strong>
            </article>

            <article class="progress-metric">
              <span class="progress-metric-label">Completadas</span>
              <strong>{{ seccionesCompletas }}/{{ avanceSecciones.length }}</strong>
            </article>

            <article class="progress-metric">
              <span class="progress-metric-label">Estados</span>
              <div class="progress-states-inline">
                <span class="progress-state-dot progress-state-dot-current" aria-label="Paso actual"></span>
                <span class="progress-state-dot progress-state-dot-progress" aria-label="Con avance"></span>
                <span class="progress-state-dot progress-state-dot-pending" aria-label="Pendiente"></span>
              </div>
            </article>
          </div>

          <div
            class="progress-bar-track"
            role="progressbar"
            aria-label="Porcentaje de avance general"
            [attr.aria-valuenow]="avanceGeneral"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div class="progress-bar-fill" [style.width.%]="avanceGeneral"></div>
          </div>

          <div class="progress-visual-grid">
            <div class="progress-sections">
              <article
                *ngFor="let seccion of avanceSecciones; let i = index"
                class="progress-section-card"
                [class.progress-section-card-complete]="seccion.completa"
                [class.progress-section-card-active]="seccion.key === pasoActivo"
                [class.progress-section-card-started]="seccion.porcentaje > 0 && !seccion.completa && seccion.key !== pasoActivo"
                [style.--progress]="seccion.porcentaje"
              >
                <div class="progress-ring-shell">
                  <div class="progress-ring">
                    <div class="progress-ring-inner">
                      <span>{{ seccion.porcentaje }}%</span>
                    </div>
                  </div>
                </div>

                <div class="progress-section-copy">
                  <div class="progress-section-head">
                    <div class="progress-section-title">
                      <span class="progress-section-badge">{{ i + 1 }}</span>
                      <strong>{{ seccion.label }}</strong>
                    </div>
                  </div>
                  <small>{{ seccion.completados }}/{{ seccion.total }} hitos completos</small>
                </div>
              </article>
            </div>

            <aside class="progress-state-panel" aria-label="Estados de avance">
              <h4>Estados</h4>
              <div class="progress-state-list">
                <article class="progress-state-item">
                  <span class="progress-state-ring progress-state-ring-current"></span>
                  <div>
                    <strong>Actual</strong>
                    <small>Seccion activa del formulario</small>
                  </div>
                </article>

                <article class="progress-state-item">
                  <span class="progress-state-ring progress-state-ring-progress"></span>
                  <div>
                    <strong>En progreso</strong>
                    <small>Con avance parcial registrado</small>
                  </div>
                </article>

                <article class="progress-state-item">
                  <span class="progress-state-ring progress-state-ring-complete"></span>
                  <div>
                    <strong>Completa</strong>
                    <small>Todos los hitos obligatorios resueltos</small>
                  </div>
                </article>

                <article class="progress-state-item">
                  <span class="progress-state-ring progress-state-ring-pending"></span>
                  <div>
                    <strong>Pendiente</strong>
                    <small>Aun sin informacion cargada</small>
                  </div>
                </article>
              </div>
            </aside>
          </div>
        </section>

        <section class="form-card stepper-card">
          <div class="stepper" role="tablist" aria-label="Pasos del formulario">
            <button
              *ngFor="let paso of pasos; let i = index"
              type="button"
              class="stepper-item"
              [class.stepper-item-active]="paso.key === pasoActivo"
              [class.stepper-item-complete]="i < indicePasoActivo"
              (click)="seleccionarPaso(paso.key)"
            >
              <span class="stepper-circle">
                <span *ngIf="i < indicePasoActivo">&#10003;</span>
                <span *ngIf="i >= indicePasoActivo">{{ i + 1 }}</span>
              </span>
              <span class="stepper-label">{{ paso.label }}</span>
            </button>
          </div>
        </section>

        <section class="form-card contest-copy-card" *ngIf="mostrarTextosConcurso">
          <details class="contest-copy-details">
            <summary>Informacion del concurso y mensajes para postulantes</summary>

            <div class="contest-copy-grid">
              <article class="contest-copy-block" *ngIf="textosConcurso?.descripcion">
                <h3>Descripcion del concurso</h3>
                <p>{{ textosConcurso?.descripcion }}</p>
              </article>

              <article class="contest-copy-block" *ngIf="textosConcurso?.instrucciones">
                <h3>Instrucciones para postulantes</h3>
                <p>{{ textosConcurso?.instrucciones }}</p>
              </article>

              <article class="contest-copy-block contest-copy-block-accent" *ngIf="textosConcurso?.mensajeSistema">
                <h3>Mensaje informativo</h3>
                <p>{{ textosConcurso?.mensajeSistema }}</p>
              </article>
            </div>
          </details>
        </section>

        <section class="form-card current-step-card">
          <div class="current-step-head">
            <div class="current-step-copy">
              <h3>{{ tituloPasoActivo }}</h3>
            </div>
            <span class="legend-chip">Campos con *: obligatorios</span>
          </div>

          <section class="step-content">
            <ng-container [ngSwitch]="pasoActivo">
              <app-postulacion-paso-informacion-general
                *ngSwitchCase="'informacion_general'"
                [formulario]="formulario"
                [soloLectura]="esSoloLectura"
                [mostrarSeccionProyecto]="mostrarSeccionProyecto"
                (changed)="registrarCambio()"
              ></app-postulacion-paso-informacion-general>

              <app-postulacion-paso-instituciones
                *ngSwitchCase="'instituciones'"
                [formulario]="formulario"
                [soloLectura]="esSoloLectura"
                (changed)="registrarCambio()"
              ></app-postulacion-paso-instituciones>

              <app-postulacion-paso-equipo-trabajo
                *ngSwitchCase="'equipo_trabajo'"
                [formulario]="formulario"
                [postulacion]="postulacion"
                [perfil]="datosPersonales"
                [rol]="rol"
                [soloLectura]="esSoloLectura"
                (changed)="registrarCambio()"
              ></app-postulacion-paso-equipo-trabajo>

              <app-postulacion-paso-presupuesto
                *ngSwitchCase="'presupuesto'"
                [formulario]="formulario"
                [soloLectura]="esSoloLectura"
                [guardando]="guardando"
                [mensajeGuardado]="mensajePresupuestoGuardado"
                [rol]="rol"
                [perfil]="datosPersonales"
                (changed)="registrarCambio()"
                (saveRequested)="guardarPresupuestoDesdeModal()"
              ></app-postulacion-paso-presupuesto>

              <app-postulacion-paso-documentos
                *ngSwitchCase="'documentos'"
                [soloLectura]="esSoloLectura"
                [formulario]="formulario"
                (changed)="registrarCambio()"
              ></app-postulacion-paso-documentos>

              <app-postulacion-paso-revision-envio
                *ngSwitchCase="'revision_envio'"
                [postulacion]="postulacion"
                [rol]="rol"
                [soloLectura]="esSoloLectura"
                [mensaje]="permisos.motivo || ''"
                [seccionesRevision]="seccionesRevision"
                [seccionesPendientes]="seccionesPendientes"
                [puedeEnviar]="envioHabilitado"
                [puedeEditar]="permisos.puedeGuardar"
                [enviando]="enviandoPostulacion"
                (solicitarEnvio)="intentarEnviarPostulacion()"
                (navegarASeccion)="irASeccionPendiente($event)"
              ></app-postulacion-paso-revision-envio>
            </ng-container>
          </section>
        </section>

        <div class="actions-row">
          <button type="button" class="btn-secondary" (click)="irAPasoAnterior()" [disabled]="!puedeRetroceder || guardando">
            Volver
          </button>

          <div class="actions-right">
            <button type="button" class="btn-outline" *ngIf="permisos.puedeGuardar" (click)="guardarBorrador()" [disabled]="guardando">
              {{ guardando ? 'Guardando...' : 'Guardar borrador' }}
            </button>
            <button type="button" class="btn-primary" *ngIf="permisos.puedeGuardar && puedeAvanzar" (click)="guardarYContinuar()" [disabled]="guardando">
              {{ guardando ? 'Guardando...' : 'Guardar y continuar' }}
            </button>
            <span class="helper-note" *ngIf="permisos.puedeGuardar">
              El formulario guarda automaticamente al cambiar de seccion y se mantiene en estado en preparacion hasta su envio.
            </span>
            <span class="helper-note" *ngIf="!permisos.puedeGuardar">
              {{ permisos.motivo || 'No hay acciones editables para este rol en la etapa actual.' }}
            </span>
          </div>
        </div>

        <div class="inline-review-panel" *ngIf="pendientesEnvioVisible">
          <div class="inline-review-head">
            <div>
              <h4>Faltan campos obligatorios</h4>
              <p>Antes de enviar la postulacion debes completar las siguientes secciones.</p>
            </div>
            <button type="button" class="btn-secondary" (click)="cerrarPendientesEnvio()">Cerrar</button>
          </div>

          <ul class="missing-sections-list">
            <li *ngFor="let seccion of seccionesPendientes">
              <div>
                <strong>{{ seccion.label }}</strong>
                <p>{{ seccion.detalle }}</p>
              </div>
              <button type="button" class="btn-outline" (click)="irASeccionPendiente(seccion.key)">Ir a seccion</button>
            </li>
          </ul>
        </div>

        <div class="inline-review-panel" *ngIf="confirmacionEnvioVisible">
          <div class="inline-review-head">
            <div>
              <h4>Confirmar envio de postulacion</h4>
              <p>Si confirmas, la postulacion quedara enviada y ya no podras seguir editandola desde este flujo.</p>
            </div>
          </div>

          <div class="placeholder-box inline-summary-box">
            <strong>Resumen:</strong>
            <span>Postulacion {{ postulacion.idPostulacion }} | Folio {{ postulacion.folio }} | Concurso {{ postulacion.concurso }}</span>
          </div>

          <div class="inline-form-actions">
            <button type="button" class="btn-secondary" (click)="cerrarConfirmacionEnvio()">Cancelar</button>
            <button type="button" class="btn-primary" (click)="confirmarEnvioPostulacion()" [disabled]="enviandoPostulacion">
              {{ enviandoPostulacion ? 'Enviando...' : 'Enviar' }}
            </button>
          </div>
        </div>
      </section>

      <ng-template #sinDetalleTpl>
        <section class="card empty-card">
          <h2>Formulario no disponible</h2>
          <p class="subtitle">{{ mensaje }}</p>
        </section>
      </ng-template>
    </main>
  </div>
</div>
